import { type BatchAddress, GeocodeRequester } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import { geocodeLatLngBatchFailed, geocodeLatLngBatchSucceeded } from '@cobliteam/store/src/Geocode/actionCreators';
import type { GeocodeLatLngBatchRequest } from '@cobliteam/store/src/Geocode/actions';
import { ActionTypes } from '@cobliteam/store/src/Geocode/actionTypes';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const env = Environment.getInstance().getEnvironment();

const geocodeRequester = new GeocodeRequester({ host: env.herbieApiHost });

export function* geocodeLatLngBatchRequestSaga(action: GeocodeLatLngBatchRequest) {
  const addresses = action.payload;
  try {
    const latLngs: BatchAddress[] = yield call(geocodeRequester.getLatLngFromAddresses, addresses);
    yield put(geocodeLatLngBatchSucceeded(latLngs));
  } catch (err) {
    yield put(geocodeLatLngBatchFailed());
  }
}

export function* GeocodeSagasListener() {
  yield all([takeLatest(ActionTypes.GEOCODE_LAT_LNG_BATCH_REQUEST, geocodeLatLngBatchRequestSaga)]);
}
